<template>
  <div class="inpBox">
    <div class="detailsTitle">
      <h4>{{id?'修改长期货源':'新建长期货源'}}</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
    <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="110px" size="mini">
      <div>
        <el-form-item label="结算客户 :" prop="payee" class="width1">
          <el-select  v-model="goodform.payee" filterable placeholder="请选择" @change="jiesuanChange">
            <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务部门:" prop="insuranceInfo"   >
          <div style="width:150px">{{goodform.businessUnit}}</div>
        </el-form-item>
        <el-form-item label="业务人员:" prop="businessUserId">
          <div v-if="ywyhFlag">{{goodform.businessUser}}</div>
          <el-select v-else  v-model="goodform.businessUserId" filterable placeholder="请选择" @change="yonghuChange">
            <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外部单号:"  >
          <el-input  placeholder=""    maxlength="50" v-model="goodform.externalOrderNumber"  ></el-input>
        </el-form-item>
        <el-form-item label="项目名称:" prop="projectType"   >
          <el-select  v-model="goodform.projectType" filterable  placeholder="请选择">
            <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型:" prop="orderBusinessType"   >
          <el-select  v-model="goodform.orderBusinessType"  placeholder="请选择" @change="ywlxChange">
            <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提货仓库:" prop="pickupWarehouse"   >
          <el-select  v-model="goodform.pickupWarehouse"  placeholder="请选择">
              <el-option  label="本库" value="本库" ></el-option>
              <el-option  label="外库" value="外库" ></el-option>
          </el-select>
        </el-form-item>
      </div>
       <hr>
      <!-- 地址组件 -->
      <addDizhi :goodform="goodform" :isCQ="true"></addDizhi>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
        </h4>
        <div>
          <el-form-item label="货物类型 :" prop="productType">
            <el-select  v-model="goodform.productType" filterable placeholder="请选择"  @change="HWLCchange">
              <el-option v-for="item in HWlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计量单位:" prop="measuringUnit" >
            <el-select  v-model="goodform.measuringUnit" filterable placeholder="请选择"  @change="measuringUnitFn" class="width2" >
              <el-option  label="吨" value="吨" ></el-option>
              <el-option  label="件" value="件" ></el-option>
              <el-option  label="方" value="方" ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="货物总量"  class="danweiBox" prop="orderWeight">
            <el-input  v-number-input.float="3"   maxlength="8"  v-model="goodform.orderWeight" key="1"
            v-if="goodform.unitMeasurement!='件'" class="width2"  ></el-input>
            <el-input  v-number-input.float="0"   maxlength="8"  v-model="goodform.orderWeight" key="2"
            v-if="goodform.unitMeasurement=='件'"  class="width2"></el-input>
            <el-select v-model="goodform.measuringUnit" placeholder="请选择">
              <el-option  label="吨" value="吨" ></el-option>
              <el-option  label="件" value="件" ></el-option>
              <el-option  label="方" value="方" ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="单车重量(吨):"  prop="weight" :rules="goodform.measuringUnit=='吨'||goodform.dun==1?rules.weight:[{required: false}]" >
            <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="goodform.weight"
            class="width2"   @change="orderWeightFn($event,'吨')"></el-input>
          </el-form-item>
          <el-form-item label="单车数量(件):" prop="orderNumber" :rules="goodform.measuringUnit=='件'||goodform.jian==1?rules.orderNumber:[{required: false}]">
            <el-input  placeholder="" v-number-input.float="0" maxlength="8"  v-model="goodform.orderNumber"
            class="width2"  @change="orderWeightFn($event,'件')"></el-input>
          </el-form-item>
          <el-form-item label="单车体积(方):" prop="volumn" :rules="goodform.measuringUnit=='方'||goodform.fang==1?rules.volumn:[{required: false}]" >
            <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="goodform.volumn"
            class="width2"   @change="orderWeightFn($event,'方')"></el-input>
          </el-form-item><br>
          <el-form-item label="需求车型:"   >
            <el-select  v-model="goodform.requiredModel" filterable placeholder="请选择">
              <el-option v-for="item in CXlist" :label="item.name" :value="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="需求车长:"   >
            <el-select  v-model="goodform.needLength" filterable placeholder="请选择">
              <el-option v-for="item in CClist" :label="item.name+'米'" :value="item.name+'米'" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回单要求:" prop="receiptRequest"   >
            <el-select  v-model="goodform.receiptRequest"  placeholder="请选择">
              <el-option  label="纸质回单" value="纸质回单" ></el-option>
              <el-option  label="电子回单" value="电子回单" ></el-option>
              <el-option  label="否" value="否" ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-calculator iconFont" aria-hidden="true"></i>客户结算</span>
        </h4>
        <div>
          <shouruCQ :goodform="goodform"></shouruCQ>
        </div>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-calculator iconFont" aria-hidden="true"></i>承运信息</span>
        </h4>
        <div>
           <el-form-item label="承运商:" prop="generalCarrier" class="width1" >
            <el-select  v-model="goodform.generalCarrier" filterable placeholder="请选择" clearable  @change="generalCarrierChange">
              <el-option v-for="item in CYSList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推送网货:" prop="onlineFreightFlag" v-if="goodform.onlineFlag==1">
            <el-radio-group v-model="goodform.onlineFreightFlag" @change="TSWHchange">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务费计算:" prop="reverseCountFlag" v-if="goodform.generalCarrier"  label-width="110px">
            <el-radio-group v-model="goodform.reverseCountFlag">
              <el-radio label="1">反算</el-radio>
              <el-radio label="0">正算</el-radio>
            </el-radio-group>
          </el-form-item>
          <zhichuCQ :goodform="goodform"></zhichuCQ>
        </div>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>其他信息</span>
        </h4>
        <div>
          <el-form-item label="摘单次数:" class="jiage" prop="pickTotalNum" >
            <el-input  placeholder="" maxlength="5" v-model.number="goodform.pickTotalNum" ></el-input><span class="danwei">次</span>
          </el-form-item>
          <el-form-item label="备注:" class="remark" prop="remark" >
            <el-input  placeholder=""  maxlength="500" v-model="goodform.remark"></el-input>
          </el-form-item>
        </div>
      </div>
      <uploadFiles :fileArr.sync='fileArr' :max=10 @remove="remove"></uploadFiles>
   </el-form>
   <div class="footerBtn" style="">
      <el-button class="bigBtn" @click="resetForm('goodform')">取消</el-button>
      <el-button type="primary" class="bigBtn" @click="saveFn">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getDictionaryDetailList, findCustomerInfoList, addSource, getOrderInfo, updateSource, getCustomerTaxRate,
  pushWayToWHPTFlag, getPrice, findKilometres, checkRequiredFields } from '@/api/newTMS'
import { selectTMSTenantListByCustom, getDepartmentUsers } from '@/api/newCrm'
import { cVLlist, cVTlist } from '@/api/vgs-driver2.0'
import addDizhi from '@/views/newTMS/publicFiles/wayAndOrder/addDizhi.vue'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import shouruCQ from '@/views/newTMS/publicFiles/wayAndOrder/shouruCQ.vue'
import zhichuCQ from '@/views/newTMS/publicFiles/wayAndOrder/zhichuCQ.vue'
export default {
  components: {
    addDizhi, shouruCQ, zhichuCQ, uploadFiles
  },
  data () {
    return {
      title: '新建长期货源',
      id: this.$route.query.id,
      HWlist: [],
      CXlist: [], // 车型
      CClist: [], // 车长
      kehuList: [],
      CYSList: [],
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        orderBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ],
        volumn: [
          { required: true, message: '请输入体积', trigger: 'blur' }
        ],
        orderNumber: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        receiptRequest: [
          { required: true, message: '请选择回单要求', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        collectionType: [
          { required: true, message: '请选择收款方类型', trigger: 'blur' }
        ],
        pickTotalNum: [
          { required: true, message: '请输入摘单次数', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        freightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        generalCarrier: [
          { required: true, message: '请选择承运商', trigger: 'blur' }
        ],
        deliverPerson: [
          { pattern: this.rule.xingming, message: '请输入正确的发货人' }
        ],
        receivingPerson: [
          { pattern: this.rule.xingming, message: '请输入正确的收货人' }
        ],
        pickupWarehouse: [
          { required: true, message: '请选择提货仓库', trigger: 'blur' }
        ]
      },
      goodform: {
        measuringUnit: '吨',
        incomePattern: '0',
        makeTicketYn: '是',
        ticketSystemYn: '否',
        revenueValuation: '0',
        ownership: 0
      },
      fileArr: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      deleteAttachmentsIds: [],
      yonghuList: [],
      ywyhFlag: false, // 客户身上是否有业务用户
      YWLXlist: [], // 业务类型
      XMlist: [], // 项目名称
      btnFlg: [],
      btnIdArr: ['004P001B000', '004P001B001']
    }
  },
  created () {
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })
    cVTlist().then(res => { this.CXlist = res })
    cVLlist().then(res => { this.CClist = res })
    getDepartmentUsers({ subOrgCode: localStorage.getItem('orgSubCode'), bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
    if (this.id) { // 列表复制按钮跳转过来
      getOrderInfo({ orderBusinessId: this.id }).then(res => {
        this.goodform = res.tOrder
        this.goodform.deleteOrderGoodsRelIds = []
        this.tOrderBusiness = res.tOrderBusiness
        console.log(this.tOrderBusiness)
        this.$set(this.goodform, 'payee', res.tOrderBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tOrderBusiness.payeeTaxId)
        this.$set(this.goodform, 'settlementCustomersCode', res.tOrderBusiness.settlementCustomersCode)
        this.$set(this.goodform, 'productType', res.tOrder.productType.toString())
        this.$set(this.goodform, 'goodsList', res.goodslist)

        for (var key in res.tOrderBusiness) {
          if (key != 'id') {
            this.$set(this.goodform, key, res.tOrderBusiness[key])
          }
        }
        if (res.tOrderBusiness.incomePattern.toString()) {
          this.$set(this.goodform, 'incomePattern', res.tOrderBusiness.incomePattern.toString())
          this.$set(this.goodform, 'incomePatternName', res.tOrderBusiness.incomePatternName)
        }
        if (res.tOrderBusiness.revenueValuation.toString()) {
          this.$set(this.goodform, 'revenueValuation', res.tOrderBusiness.revenueValuation.toString())
          this.$set(this.goodform, 'revenueValuationName', res.tOrderBusiness.revenueValuationName)
        }
        this.$set(this.goodform, 'incomeUnitPrice', res.tOrderBusiness.incomeUnitPrice / 100)
        this.$set(this.goodform, 'incomeAmount', res.tOrderBusiness.incomeAmount / 100)
        res.tAttachmentsList.forEach(item => {
          var filename = item.url.substring(item.url.lastIndexOf('/') + 1)
          this.fileArr.push({ status: 'ready', url: item.fileKeyUrl, id: item.id, name: filename })
        })

        this.$set(this.goodform, 'orderBusinessType', res.tOrder.orderBusinessType.toString())

        // 运力支出相关
        this.$set(this.goodform, 'collectionType', res.tOrderBusiness.collectionType)
        this.$set(this.goodform, 'generalCarrier', res.tOrderBusiness.generalCarrier)
        this.$set(this.goodform, 'generalTaxId', res.tOrderBusiness.generalTaxId)
        this.$set(this.goodform, 'collectionType', res.tOrderBusiness.collectionType)
        this.$set(this.goodform, 'payer', res.tOrderBusiness.payer)
        this.$set(this.goodform, 'payerTaxId', res.tOrderBusiness.payerTaxId)
        if (res.tOrderBusiness.expenditurePattern || res.tOrderBusiness.expenditurePattern === 0) {
          this.$set(this.goodform, 'expenditurePattern', res.tOrderBusiness.expenditurePattern.toString())
          this.$set(this.goodform, 'expenditurePatternName', res.tOrderBusiness.expenditurePatternName)
        }
        if (res.tOrderBusiness.freightPricingType || res.tOrderBusiness.freightPricingType === 0) {
          this.$set(this.goodform, 'freightPricingType', res.tOrderBusiness.freightPricingType.toString())
          this.$set(this.goodform, 'freightPricingTypeName', res.tOrderBusiness.freightPricingTypeName)
        }
        if (res.tOrderBusiness.freightUnitPrice) {
          this.$set(this.goodform, 'freightUnitPrice', res.tOrderBusiness.freightUnitPrice / 100)
        }
        if (res.tOrderBusiness.freightAmount) {
          this.$set(this.goodform, 'freightAmount', res.tOrderBusiness.freightAmount / 100)
        }
        this.$set(this.goodform, 'serviceRate', res.tOrderBusiness.serviceRate)
        this.$set(this.goodform, 'serviceCharge', res.tOrderBusiness.serviceCharge / 100)
        this.$set(this.goodform, 'freightTaxRate', res.tOrderBusiness.freightTaxRate)

        this.$set(this.goodform, 'onlineFreightFlag', Number(res.tOrderBusiness.onlineFreightFlag))

        // 判断业务用户是否可选
        findCustomerInfoList({ businessType: 1 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.kehuList = res1
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            if (json[0].businessUserCode) {
              this.ywyhFlag = true
            } else {
              this.ywyhFlag = false
            }
          })
        })
        // 判断是否推送网货是否显示
        findCustomerInfoList({ businessType: 2 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.CYSList = res1
            let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
            if (json.length > 0) {
              this.$set(this.goodform, 'onlineFlag', json[0].onlineFlag)
            } else {
              this.$set(this.goodform, 'onlineFlag', null)
            }
          })
        })

        // 根据货物类型判断吨件方必填
        getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => {
          this.HWlist = res
          // let json = this.HWlist.filter(item => item.itemNo == this.goodform.productType)
          // this.$set(this.goodform, 'dun', json[0].ext1)
          // this.$set(this.goodform, 'jian', json[0].ext2)
          // this.$set(this.goodform, 'fang', json[0].ext3)
        })
        // 编辑的时候获取公里数
        this.getGLS()
      })
    } else {
      findCustomerInfoList({ businessType: 1 }).then(res => {
        selectTMSTenantListByCustom(res).then(res1 => { this.kehuList = res1 })
      })
      findCustomerInfoList({ businessType: 2 }).then(res => {
        selectTMSTenantListByCustom(res).then(res1 => { this.CYSList = res1 })
      })
      this.$set(this.goodform, 'businessUnit', localStorage.getItem('orgName'))
      this.$set(this.goodform, 'businessUnitCode', localStorage.getItem('orgCode'))
      this.$set(this.goodform, 'businessSubunit', localStorage.getItem('orgSubName'))
      this.$set(this.goodform, 'businessSubunitCode', localStorage.getItem('orgSubCode'))
      this.$set(this.goodform, 'businessTenantCode', localStorage.getItem('tenantCode'))
      this.$set(this.goodform, 'businessTenantName', localStorage.getItem('tenantName'))
      this.$set(this.goodform, 'businessCompanyName', localStorage.getItem('companyName'))
      this.$set(this.goodform, 'businessCompanyCode', localStorage.getItem('companyCode'))
      getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
      this.$set(this.goodform, 'taxRate', 9)
    }
  },
  computed: {
    listenChange () {
      const { productType, payee, kilometres } = this.goodform
      return { productType, payee, kilometres }
    }
  },
  watch: {
    listenChange () {
      this.getflagFn()
    }
  },
  methods: {
    // 判断吨件方是否必填
    getflagFn () {
      if (this.goodform.payee && this.goodform.kilometres && this.goodform.productTypeName) {
        checkRequiredFields({
          itemNo: this.goodform.payee,
          showName: this.goodform.productTypeName,
          kilometres: this.goodform.kilometres
        }).then(res => {
          this.$set(this.goodform, 'dun', res.weight)
          this.$set(this.goodform, 'jian', res.number)
          this.$set(this.goodform, 'fang', res.volumn)
        })
      }
    },
    getGLS () {
      if (this.goodform.deliverLongitude && this.goodform.receivingLongitude) {
        findKilometres({
          deliverLongitude: this.goodform.deliverLongitude,
          deliverLatitude: this.goodform.deliverLatitude,
          receivingLongitude: this.goodform.receivingLongitude,
          receivingLatitude: this.goodform.receivingLatitude,
          arriveDepartFlag: this.goodform.arriveDepartFlag
        }).then(res => {
          this.$set(this.goodform, 'kilometres', res)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        this.$set(this.goodform, 'kilometres', '0')
      }
    },
    // 选择业务类型
    ywlxChange () {
      let yewuleixingJson = this.YWLXlist.filter(item => item.itemNo == this.goodform.orderBusinessType)
      this.goodform.orderBusinessTypeName = yewuleixingJson[0].showName
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'businessUser', json[0].userName)
    },
    // 计量单位改变
    measuringUnitFn (danwei) {
      if (this.goodform.revenueValuation != 1) {
        if (danwei == '吨') {
          this.$set(this.goodform, 'revenueValuation', '0')
          this.$set(this.goodform, 'revenueValuationName', '按吨')
        } else if (danwei == '件') {
          this.$set(this.goodform, 'revenueValuation', '3')
          this.$set(this.goodform, 'revenueValuationName', '按件')
        } else if (danwei == '方') {
          this.$set(this.goodform, 'revenueValuation', '2')
          this.$set(this.goodform, 'revenueValuationName', '按方')
        }
      }
      if (this.goodform.freightPricingType != 1) {
        if (danwei == '吨') {
          this.$set(this.goodform, 'freightPricingType', '0')
          this.$set(this.goodform, 'freightPricingTypeName', '按吨')
        } else if (danwei == '件') {
          this.$set(this.goodform, 'freightPricingType', '3')
          this.$set(this.goodform, 'freightPricingTypeName', '按件')
        } else if (danwei == '方') {
          this.$set(this.goodform, 'freightPricingType', '2')
          this.$set(this.goodform, 'freightPricingTypeName', '按方')
        }
      }
      this.orderWightFuzhi()
    },
    // 货物重量改变
    orderWeightFn (e, danwei) {
      if (e != '' && Number(e) === 0) {
        this.$alert('输入的值不能为0', '系统提示')
        if (danwei == '吨') {
          this.$set(this.goodform, 'weight', '')
        } else if (danwei == '件') {
          this.$set(this.goodform, 'orderNumber', '')
        } else if (danwei == '方') {
          this.$set(this.goodform, 'volumn', '')
        }
      }
      this.orderWightFuzhi()
    },
    orderWightFuzhi () {
      if (this.goodform.measuringUnit == '吨') {
        this.$set(this.goodform, 'orderWeight', this.goodform.weight)
      } else if (this.goodform.measuringUnit == '件') {
        this.$set(this.goodform, 'orderWeight', this.goodform.orderNumber)
      } else if (this.goodform.measuringUnit == '方') {
        this.$set(this.goodform, 'orderWeight', this.goodform.volumn)
      }
    },
    saveFn (n) {
      if (!this.goodform.deliverAddressId) {
        this.$alert('请选择发货地址', '系统提示')
        return
      }
      if (!this.goodform.receivingAddressId) {
        this.$alert('请选择收货地址', '系统提示')
        return
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          if (this.id) { // 修改逻辑
            let data = {}
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            if (json.length > 0) {
              data.payeeCode = json[0].tenantCode
            } else {
              console.log(json)
            }
            data.tOrder = this.goodform
            data.deleteAttachmentsIds = this.deleteAttachmentsIds

            data.tOrderBusiness = this.tOrderBusiness// 把业务实体整个赋值
            data.tOrderBusiness.payeeTaxId = this.goodform.payeeTaxId
            data.tOrderBusiness.payee = this.goodform.payee
            data.tOrderBusiness.generalTaxId = this.goodform.generalTaxId
            data.tOrderBusiness.generalCarrier = this.goodform.generalCarrier
            data.tOrderBusiness.onlineFreightFlag = this.goodform.onlineFreightFlag
            data.tOrderBusiness.incomePattern = this.goodform.incomePattern
            data.tOrderBusiness.makeTicketYn = this.goodform.makeTicketYn
            data.tOrderBusiness.ticketSystemYn = this.goodform.ticketSystemYn
            data.tOrderBusiness.revenueValuation = this.goodform.revenueValuation
            data.tOrderBusiness.incomeUnitPrice = this.goodform.incomeUnitPrice
            data.tOrderBusiness.incomePatternName = this.goodform.incomePatternName
            data.tOrderBusiness.revenueValuationName = this.goodform.revenueValuationName
            data.tOrderBusiness.incomeAmount = this.goodform.incomeAmount
            data.tOrderBusiness.expenditurePattern = this.goodform.expenditurePattern
            data.tOrderBusiness.freightPricingType = this.goodform.freightPricingType
            data.tOrderBusiness.expenditurePatternName = this.goodform.expenditurePatternName
            data.tOrderBusiness.freightPricingTypeName = this.goodform.freightPricingTypeName
            data.tOrderBusiness.freightUnitPrice = this.goodform.freightUnitPrice
            data.tOrderBusiness.freightAmount = this.goodform.freightAmount
            data.tOrderBusiness.serviceRate = this.goodform.serviceRate
            data.tOrderBusiness.serviceCharge = this.goodform.serviceCharge
            data.tOrderBusiness.freightTaxRate = this.goodform.freightTaxRate
            data.tOrderBusiness.taxRate = this.goodform.taxRate

            data.tOrderBusiness.payer = this.goodform.payer
            data.tOrderBusiness.payerTaxId = this.goodform.payerTaxId
            data.tOrderBusiness.payerCode = this.goodform.payerCode
            let imgfile = new FormData()
            imgfile.append('params', JSON.stringify(data))
            this.fileArr.forEach(item => {
              if (!item.id) {
                imgfile.append('files', item.raw)
              }
            })
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            updateSource(imgfile).then(res => {
              loading.close()
              this.$router.push({ name: 'longGoods' })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            this.goodform.payeeTaxId = json[0].customerTaxId
            this.goodform.settlementCustomersCode = json[0].tenantCode
            let imgfile = new FormData()
            imgfile.append('params', JSON.stringify(this.goodform))
            this.fileArr.forEach(item => {
              imgfile.append('files', item.raw)
            })
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            addSource(imgfile).then(res => {
              loading.close()
              this.$router.push({ name: 'longGoods' })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.deleteAttachmentsIds.push(file.id)
      }
    },
    // 推送网货改变
    TSWHchange () {
      let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
      this.whLuoji(json)
    },
    // 推送网货逻辑
    whLuoji (json) {
      if (this.goodform.onlineFreightFlag == 1) {
        pushWayToWHPTFlag().then(res => {
          if (res) {
            this.$set(this.goodform, 'WHJKflag', true)
            getCustomerTaxRate({ orderBusinessId: this.goodform.orderBusinessId ? this.goodform.orderBusinessId : null }).then(res => {
              this.$set(this.goodform, 'serviceRate', res * 100)
            }).catch(error => {
              this.$set(this.goodform, 'serviceRate', null)
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                }
              })
            })
          } else {
            this.$set(this.goodform, 'WHJKflag', false)
            this.$set(this.goodform, 'serviceRate', json[0].serviceRate)
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        this.$set(this.goodform, 'WHJKflag', false)
        this.$set(this.goodform, 'serviceRate', json[0].serviceRate)
      }
    },
    // 承运商改变
    generalCarrierChange (e) {
      if (e) {
        let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
        this.goodform.generalTaxId = json[0].customerTaxId
        this.goodform.generalPeriodDays = json[0].periodDays
        this.goodform.generalInvoiceDays = json[0].invoiceDays
        this.goodform.generalPeriodDaysType = json[0].periodDaysType
        this.$set(this.goodform, 'collectionType', 1)
        this.$set(this.goodform, 'payer', this.goodform.generalCarrier)
        this.$set(this.goodform, 'payerTaxId', json[0].customerTaxId)
        this.$set(this.goodform, 'payerCode', json[0].tenantCode)
        this.$set(this.goodform, 'onlineFlag', json[0].onlineFlag)
        this.$set(this.goodform, 'onlineFreightFlag', json[0].onlineFreightFlag)
        this.$set(this.goodform, 'reverseCountFlag', json[0].reverseCountFlag)
        this.$set(this.goodform, 'expenditurePattern', json[0].settlementType)
        this.$set(this.goodform, 'expenditurePatternName', json[0].settlementTypeName)
        this.$set(this.goodform, 'freightTaxRate', json[0].taxRate)
        this.whLuoji(json)
      } else {
        this.$set(this.goodform, 'onlineFreightFlag', null)
        this.$set(this.goodform, 'reverseCountFlag', null)
        this.$set(this.goodform, 'serviceRate', 0)
        this.goodform.generalTaxId = null
        this.goodform.generalPeriodDays = null
        this.$set(this.goodform, 'collectionType', 1)
        this.$set(this.goodform, 'payer', null)
        this.$set(this.goodform, 'payerTaxId', null)
        this.$set(this.goodform, 'payerCode', null)
      }
    },
    // 运力改变
    yunliChange (e) {
      this.$set(this.goodform, 'generalCarrier', '')
      this.$set(this.goodform, 'generalTaxId', '')
      if (e == 1) { // 外协
        this.$set(this.goodform, 'payer', '')
        this.$set(this.goodform, 'payerTaxId', '')
      } else { // 自有0
        this.$set(this.goodform, 'payer', '唐山薪伙伴科技有限公司')
        this.$set(this.goodform, 'payerTaxId', '91130230MA7L1EB616')
      }
    },
    // 选择结算客户
    jiesuanChange () {
      let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
      this.goodform.payeeTaxId = json[0].customerTaxId
      this.goodform.periodDays = json[0].periodDays
      this.goodform.periodDaysType = json[0].periodDaysType
      if (json[0].businessUserCode) {
        this.ywyhFlag = true
        this.$set(this.goodform, 'businessUserId', json[0].businessUserCode)
        this.$set(this.goodform, 'businessUser', json[0].businessUserName)
      } else {
        this.ywyhFlag = false
        this.$set(this.goodform, 'businessUserId', null)
        this.$set(this.goodform, 'businessUser', null)
      }
    },
    // 货物类型改变
    HWLCchange (e) {
      let json = this.HWlist.filter(item => item.itemNo == e)
      this.$set(this.goodform, 'productTypeName', json[0].showName)
      // this.goodform.dun = json[0].ext1
      // this.goodform.jian = json[0].ext2
      // this.goodform.fang = json[0].ext3
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    resetForm () {
      this.$router.push({ name: 'longGoods' })
    }

  }

}
</script>

<style scoped lang='less'>

.imgBox{
  margin: 22px 10px;
}

.hidden /deep/.el-upload--picture-card{
  display: none;
}
.danweiBox{
  /deep/.el-input{
    width: auto;
  }
  /deep/.el-select{
    width: 60px;
    .el-input__inner{
    width: 60px;
  }
  }
}
.width1  /deep/.el-input__inner{
  width: 260px;
}
.width2  /deep/.el-input__inner{
    width: 90px;
}
/deep/.el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
</style>
